import React from 'react';

const HeaderSocials = () => {
    return (
        <div className="home__socials">
            <a href="https://www.facebook.com/mohimin.ahad" className="home__social-link" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-facebook"></i> 
            </a>
            <a href="https://www.twitter.com/" className="home__social-link" target="_blank" rel="noreferrer">
                 <i className="fa-brands fa-twitter"></i>
            </a>
            <a href="https://github.com/ahad30" className="home__social-link" target="_blank" rel="noreferrer">
                 <i className="fa-brands fa-github"></i>
            </a>
            <a href="https://www.instagram.com/" className="home__social-link" target="_blank" rel="noreferrer">
                 <i className="fa-brands fa-instagram"></i>
            </a>
            <a href="www.linkedin.com/in/mohiminul-islam-ahad" className="home__social-link" target="_blank" rel="noreferrer">
                 <i className="fa-brands fa-linkedin"></i>
            </a>

        </div>
    );
}

export default HeaderSocials